/* src/app/components/auth-usage-charts/spending-plan/monthly-spending-plan-summary/monthly-spending-plan-summary.component.css */
.monthly-spending-summary-table {
  text-align: left;
  font-size: 14px;
}
.monthly-spending-summary-table th {
  background-color: #f5f5f5;
  padding: 8px;
  text-align: left;
  border: 1px solid #eee;
}
.monthly-spending-summary-table td {
  padding: 12px;
  border: 1px solid #eee;
}
.monthly-spending-summary-table .total-row {
  font-weight: 600;
  background-color: #fafafa;
}
.monthly-spending-summary-table th {
  background: #004c4a;
  color: white;
}
.table-wrapper {
  overflow-x: auto;
  max-width: 100%;
}
table {
  width: 100%;
  border-collapse: collapse;
  min-width: 800px;
}
th,
td {
  padding: 8px 12px;
  border: 1px solid #ddd;
  white-space: nowrap;
}
th {
  background-color: #e6f0fa;
  font-weight: bold;
  position: sticky;
  top: 0;
}
.chart-container ::ng-deep .bar-chart-container {
  max-width: none;
  height: 300px;
}
@media (max-width: 1024px) {
  .chart-container ::ng-deep .bar-chart-container {
    max-width: none;
    height: 280px;
  }
}
.monthly-head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 8px 16px;
  margin: 0 4px 12px;
}
.monthly-title {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #6b6b6b;
}
.monthly-note {
  margin: 2px 0 0;
  font-size: 12px;
  color: #8c8c8c;
}
/*# sourceMappingURL=monthly-spending-plan-summary.component-RKXRK7AJ.css.map */
